import React, { Component } from 'react';
import {
  HashRouter,
  Switch,
  Route 
 } from 'react-router-dom'

import LandingPage from "./containers/LandingPage/LandingPage"
import DemoFeaturesPage from "./containers/DemoFeaturesPage/DemoFeaturesPage"
import PublicationsPage from "./containers/PublicationsPage/PublicationsPage"
import DocsPage from './containers/DocsPage/DocsPage'
import ContactPage from "./containers/ContactPage/ContactPage"

const NoMatch = ({ location }) => (
  <h3>No page found for <code>{location.pathname}</code></h3>
)

class App extends Component {
  render() {
    return (
      <HashRouter>
        {/* Hash history usually will work without any server
          configuration. The URL will look something like:
          http://www.example.com/#/route1/route2/
        */}
        <Switch>
          <Route
            exact
            path='/'
            component={LandingPage}
          />
          <Route
            exact
            path='/demo-features'
            component={DemoFeaturesPage}
          />
          <Route
            exact
            path='/publications'
            component={PublicationsPage}
          />
          <Route
            path='/docs'
            component={DocsPage}
          />
          <Route
            exact
            path='/contact'
            component={ContactPage}
          />
          <Route component={NoMatch} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
